import {Injectable, signal} from '@angular/core';
import {
  DailyFeedbackReportsData,
  DailyFeedbackReportsPagination
} from "../types/daily-feedback-reports-page.types";
import {
  defaultDailyFeedbackReportsPaginationData,
  defaultPaginationProps
} from "../configs/daily-feedback-reports-page-pagination-config";
import {PaginationProps} from "../types/daily-feedback-reports-page-pagination.types";
import {PageEvent} from "@angular/material/paginator";

@Injectable({
  providedIn: 'root'
})
export class DailyFeedbackReportsPaginationDataService {
  private _dailyFeedbackReportsPaginationData = signal<DailyFeedbackReportsPagination>(defaultDailyFeedbackReportsPaginationData);
  public dailyFeedbackReportsPaginationData = this._dailyFeedbackReportsPaginationData.asReadonly();
  private _paginationProps = signal<PaginationProps>(defaultPaginationProps);
  public paginationProps = this._paginationProps.asReadonly();

  public setDailyFeedbackReportsPagination(data: DailyFeedbackReportsData | null): void {
    this._dailyFeedbackReportsPaginationData.set(data ?
      {
        size: data.size,
        number: data.number,
        totalPages: data.totalPages,
        totalElements: data.totalElements,
        numberOfElements: data.numberOfElements
      } :
      defaultDailyFeedbackReportsPaginationData);
  }

  public updatePaginationProps({ pageIndex, pageSize }: PageEvent): void {
    this._paginationProps.update(currentState => ({
      ...currentState,
      page: pageIndex,
      size: pageSize
    }));
  }

  public goToPage(selectTablePage: number): void {
    this._paginationProps.update(currentState => ({
      ...currentState,
      page: selectTablePage - 1
    }));
  }

  public resetPaginationProps(): void {
    this._paginationProps.set(defaultPaginationProps);
  }
}
